module.exports = __webpack_public_path__ + "bdce52248c77d0eeb69dd2802f593e6e.svg";